"use client";

// Le bouton qui passe la main à l'agent : il pré-remplit le chat, à gauche de l'écran. Il en a la forme : une
// languette dont la pointe part vers la gauche, comme la queue d'une bulle tournée vers le chat, avec les trois
// briques de minibreek. On le pose toujours à gauche de son bloc, au plus près du chat.

import type { ReactNode } from "react";
import "./demander.css";

export function Briques({ className = "" }: { className?: string }) {
  return (
    <svg className={`logo-briques ${className}`} viewBox="0 0 26 20" aria-hidden>
      <rect className="ocre" x="2" y="1" width="15" height="5" rx="2" />
      <rect className="rouge" x="8" y="7.5" width="15" height="5" rx="2" />
      <rect className="noire" x="2" y="14" width="15" height="5" rx="2" />
    </svg>
  );
}

export function DemanderAgent({
  onDemander,
  children = "Demander à l'agent",
  petit = false,
  disabled,
  className = "",
}: {
  onDemander: () => void;
  children?: ReactNode;
  petit?: boolean; // dans une ligne d'actions serrée (une fiche, un jalon)
  disabled?: boolean;
  className?: string;
}) {
  return (
    <button
      type="button"
      className={`demander-agent${petit ? " petit" : ""} ${className}`}
      disabled={disabled}
      onClick={onDemander}
    >
      <Briques />
      <span>{children}</span>
    </button>
  );
}
